import Axios from 'axios'
// 刷新token
export function BalanceParaSet(id) {
    return Axios
        .get('Balance/BalanceParaGet', {
            params: {
                id: id
            }
        })
        .then((res) => {
            if (res.status === 200) {
                return res.data;
            } else {
                Promise.reject();
            }
        })
        .catch((err) => this.$notify.error('网络异常！'));
}